/** 人员工作队列、其通道与紧急程度、负责人分配以及仪表板上的队列数据（规划第三阶段 P3-4）。 */
export default {
  queue: {
    view: { label: '视图', list: '列表', queue: '队列' },
    title: '工作队列',
    subtitle: '按最近期限排序的未结提交。',
    asAt: '紧急程度截至 {{time}}',
    lanes: {
      label: '轮到谁',
      authority: '我方期限',
      response: '等待他方',
      lapse: '可能失效的许可',
    },
    bands: {
      label: '按紧急程度筛选',
      all: '全部',
      overdue: '已逾期',
      due_soon: '即将到期',
      on_track: '进度正常',
      applicant_turn: '轮到申请人',
      uncovered: '日历未涵盖',
      none: '无期限',
    },
    mine: '我的案件',
    columns: {
      case: '提交',
      stage: '步骤',
      deadline: '期限',
      band: '紧急程度',
      kpktDays: 'KPKT 天数',
      days: '天数',
      applicantDays: '申请人天数',
      assignee: '负责人',
    },
    daysOf: '{{units}} 天中的第 {{days}} 天',
    dueOn: '{{date}} 到期',
    uncoveredDue: '日历涵盖前无日期',
    unassigned: '未分配',
    assignLabel: '分配 {{caseRef}}',
    assignFailed: '分配未保存：{{message}}',
    empty: '此队列中没有未结提交。',
    emptyMine: '此队列中没有分配给您的未结提交。',
    summary: {
      title: '期限',
      hint: '按紧急程度统计的未结提交；点击数字打开对应队列。',
      onTime: '按规模统计的准时情况',
      scale: '规模',
      clock: '期限',
      met: '准时',
      missed: '逾期',
      share: '准时比例',
      noScale: '无规模',
      none: '尚无已达成或错过的期限。',
    },
  },
  errors: {
    invalid_assignee: '无法分配此人：请选择可以处理提交的人员。',
  },
}
